import { getNumberOfFiltersApplied as getNumberOfFiltersAppliedSelector } from '@vista-digital/occ-domain';
export const getNumberOfFiltersApplied = (props) => {
    return getNumberOfFiltersAppliedSelector(props);
};
//# sourceMappingURL=get-number-of-filters-applied.js.map